import * as types from './constants';

// Get Shopify Product Variants
export const getShopifyProductVariantsRequest = data => (
  { type: types.GET_SHOPIFY_PRODUCT_VARIANTS_REQUEST, payload: data }
);

export const getShopifyProductVariantsDone = data => (
  { type: types.GET_SHOPIFY_PRODUCT_VARIANTS_DONE, payload: data }
);

export const getShopifyProductVariantsFailed = errors => (
  { type: types.GET_SHOPIFY_PRODUCT_VARIANTS_FAILED, payload: errors }
);

export const getShopifyProductVariantsReset = () => (
  { type: types.GET_SHOPIFY_PRODUCT_VARIANTS_RESET }
);
